import { supportedBrowsers, supportedBrowsersRegex } from '@ctw/shared/utils/supported-browsers';
import Bowser from 'bowser';
import { useCallback, useEffect, useState } from 'react';

const SUPPORTED_BROWSERS = new Set(supportedBrowsers.map((browser) => browser.split(' ')[0]));

export const useBrowserCompatibility = () => {
  const [browser, setBrowser] = useState<Bowser.Parser.BrowserDetails | null>(null);
  const [readableBrowserString, setReadableBrowserString] = useState<string>('Unknown browser');

  useEffect(() => {
    if (typeof navigator !== 'undefined' && navigator.userAgent) {
      const parsed = Bowser.getParser(navigator.userAgent);
      const browserDetails = parsed.getBrowser();
      setBrowser(browserDetails);

      const name = browserDetails.name ?? 'Unknown browser';
      const version = browserDetails.version ?? null;
      setReadableBrowserString(version ? `${name} v${version}` : `${name}`);
    }
  }, []);

  const isBrowserSupported = useCallback((): boolean => {
    if (typeof navigator === 'undefined' || !navigator.userAgent) {
      return false;
    }
    return supportedBrowsersRegex.test(navigator.userAgent);
  }, []);

  return { isBrowserSupported, SUPPORTED_BROWSERS, browser, readableBrowserString };
};
